module.exports = __webpack_public_path__ + "static/media/wtc.7de51d84.svg";